<script>
  import { onMount } from "svelte";
  import ProtectedRoute from "../components/ProtectedRoute.svelte";
  import Header from "../components/Header.svelte";

  let qrImages = [];
  let errorMessage = "";
  let loading = true;

  const generateQRCode = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const token = userData.token;
      // console.log("Token:", token);

      const numQR = Math.floor(Math.random() * 3) + 2;

      const responses = await Promise.all(
        Array.from({ length: numQR }, async () => {
          const response = await fetch(
            "https://api.trulens.ae/api/qr/generate",
            {
              headers: {
                Authorization: token,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to generate QR code");
          }

          return response.blob();
        })
      );

      qrImages = await Promise.all(
        responses.map((blob) => URL.createObjectURL(blob))
      );
    } catch (error) {
      // console.error("Error:", error);
      errorMessage = error.message || "Failed to generate QR code";
    } finally {
      loading = false;
    }
  };

  onMount(generateQRCode);
</script>

<ProtectedRoute>
  <Header />
  <div class="title">
    <span class="title-span">Camera Verification</span>
  </div>

  <main>
    {#if loading}
      <div style="text-align: center;">
        <p>Loading...</p>
      </div>
    {:else if errorMessage}
      <div style="color: red; margin-bottom: 10px;">{errorMessage}</div>
    {:else}
      <div>
        <h3 style="text-align: center;">
          Scan These QR Codes Using TruLens Application to Verify Your Account!
        </h3>
        <div style="display: flex; justify-content: center;">
          {#each qrImages as qrImageSrc}
            <div style="margin: 10px;">
              <img
                src={qrImageSrc}
                alt=""
                style="max-width: 300px; max-height: 300px;"
              />
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </main>
</ProtectedRoute>

<style>
  .title {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(135, 135, 135, 0.1);
    /* background: linear-gradient(to bottom, #FF3C82 45%, #1e92ff 55%); */
    /* background: linear-gradient(130deg, #cdb4db, #ffffff);
    box-shadow:
      inset -20px 0 50px #cdb4db,
      inset 20px 0 50px #cdb4db; */
  }

  .title-span {
    margin-top: 5px;
    /* border: 2px solid #000000; */
    border-radius: 25%;
    /* margin: 0 15px; */
    padding: 5px;
    font-size: 1.2rem;
    color: #000000;
    /* text-decoration: underline; */
    /* cursor: pointer; */
    font-size: 1.4rem;
    font-weight: bold;
  }

  main {
    height: 100vh;
    margin: 0;
    /* display: flex; */
    justify-content: center;
    align-items: center;
  }

  img {
    max-width: 250px;
    max-height: 250px;
  }

  @media (max-width: 768px) {
    .title {
      padding: 10px 20px;
    }

    .title-span {
      font-size: 1.2rem;
    }

    main {
      height: auto;
      padding: 20px;
      text-align: center;
    }

    img {
      width: 100%;
      height: 100%;
    }

    .qr-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    .qr-container div {
      flex: 1 1 45%;
      margin: 5px;
    }
  }

  @media screen and (min-width: 768px) {
    .title {
      margin-top: 40px;
    }
  }

  @media screen and (min-width: 850px) {    
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 850px) and (min-height: 1280px) {    
    .title {
      margin-top: 55px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1024px) and (max-height: 600px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 1024px) and (min-height: 1300px) {
    .title {
      margin-top: 60px;
    }
  }

  @media screen and (min-width: 1440px) {
    .title {
      margin-top: 20px;
    }
  }
</style>
